// crm namespace — Promote (PromoteButton + PromoteModal, C3.02/C3.04, lane F4). Flat
// dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js). Gendered
// spec wording ("her listing") is neutral here: no client/practitioner gender is stored.
export default {
  fr: {
    "promote.cta": "Mettre en avant",
    "promote.runningLabel": "Mis en avant",
    "promote.stopCta": "Arrêter",
    "promote.modalTitle": "Mettre en avant",
    "promote.type.course": "Formation",
    "promote.type.product": "Produit",
    "promote.type.profile": "Profil public",
    "promote.what.confirm": "Confirmer",
    "promote.durationOption": "{d} jours",
    "promote.priceLabel": "Prix",
    "promote.buyBooster": "Activer le module de mise en avant",
    "promote.boosterOwned": "Module de mise en avant activé",
    "promote.boosterBlocked": "Le module de mise en avant n'a pas pu être activé. Le support Solunary remboursera le montant prélevé.",
    "promote.placementBar": "En tête de la catégorie {category}",
    "promote.featuredStrip": "Bandeau vedette",
    "promote.back": "Retour",
    "promote.next": "Suivant",
    "promote.confirmSummaryProfile": "{item} · {d} jours · en tête de la catégorie {category}",
    "promote.confirmSummaryFeatured": "{item} · {d} jours · bandeau vedette du marché",
    "promote.total": "Total",
    "promote.start": "Démarrer la mise en avant",
    "promote.liveNote": "Actif immédiatement, avec l'étiquette « Mis en avant »",
    "promote.quoteFailed": "Impossible de calculer le prix. Réessayez.",
    "promote.startFailed": "La mise en avant n'a pas pu démarrer. Réessayez.",
    "promote.returnBlocked": "L'achat n'a pas pu être finalisé. Le support Solunary remboursera le montant prélevé.",
    "promote.returnCancelled": "Mise en avant annulée.",
  },
  en: {
    "promote.cta": "Promote",
    "promote.runningLabel": "Promoted",
    "promote.stopCta": "Stop",
    "promote.modalTitle": "Promote",
    "promote.type.course": "Course",
    "promote.type.product": "Product",
    "promote.type.profile": "Public profile",
    "promote.what.confirm": "Confirm",
    "promote.durationOption": "{d} days",
    "promote.priceLabel": "Price",
    "promote.buyBooster": "Turn on the promotion module",
    "promote.boosterOwned": "Promotion module on",
    "promote.boosterBlocked": "The promotion module could not be turned on. Solunary support will refund the charge.",
    "promote.placementBar": "Top of {category} category",
    "promote.featuredStrip": "Featured strip",
    "promote.back": "Back",
    "promote.next": "Next",
    "promote.confirmSummaryProfile": "{item} · {d} days · top of {category} category",
    "promote.confirmSummaryFeatured": "{item} · {d} days · marketplace featured strip",
    "promote.total": "Total",
    "promote.start": "Start promotion",
    "promote.liveNote": "Live immediately, labelled [Promoted]",
    "promote.quoteFailed": "The price could not be calculated. Try again.",
    "promote.startFailed": "The promotion could not start. Try again.",
    "promote.returnBlocked": "The purchase could not be completed. Solunary support will refund the charge.",
    "promote.returnCancelled": "Promotion cancelled.",
  },
  es: {
    "promote.cta": "Promocionar",
    "promote.runningLabel": "Promocionado",
    "promote.stopCta": "Detener",
    "promote.modalTitle": "Promocionar",
    "promote.type.course": "Curso",
    "promote.type.product": "Producto",
    "promote.type.profile": "Perfil público",
    "promote.what.confirm": "Confirmar",
    "promote.durationOption": "{d} días",
    "promote.priceLabel": "Precio",
    "promote.buyBooster": "Activar el módulo de promoción",
    "promote.boosterOwned": "Módulo de promoción activado",
    "promote.boosterBlocked": "No se pudo activar el módulo de promoción. El soporte de Solunary reembolsará el cargo.",
    "promote.placementBar": "En lo alto de la categoría {category}",
    "promote.featuredStrip": "Franja destacada",
    "promote.back": "Atrás",
    "promote.next": "Siguiente",
    "promote.confirmSummaryProfile": "{item} · {d} días · en lo alto de la categoría {category}",
    "promote.confirmSummaryFeatured": "{item} · {d} días · franja destacada del mercado",
    "promote.total": "Total",
    "promote.start": "Iniciar promoción",
    "promote.liveNote": "Activo de inmediato, con la etiqueta «Promocionado»",
    "promote.quoteFailed": "No se pudo calcular el precio. Inténtalo de nuevo.",
    "promote.startFailed": "La promoción no pudo iniciarse. Inténtalo de nuevo.",
    "promote.returnBlocked": "No se pudo completar la compra. El soporte de Solunary reembolsará el cargo.",
    "promote.returnCancelled": "Promoción cancelada.",
  },
};
